<template>
  <CRow>
    <CCol class="main-label">
      <div class="parent-wrapper" @click="open = !open">
        <h2>{{ main.label }}</h2>
        <img
          v-show="!open"
          class="circle-icon plus-circle-icon"
          :src="plusCircleSrc"
          alt="plus-circle"
        />
        <img
          v-show="open"
          class="circle-icon minus-circle-icon"
          :src="minusCircleSrc"
          alt="minus-circle"
        />
      </div>
    </CCol>
  </CRow>
  <Children
    v-bind:key="`second-${mainIndex}-${index}`"
    v-for="(child, index) in main.children"
    :child="child"
    :main-index="mainIndex"
    :child-index="index"
    :class="{ 'is-hidden': !open }"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ParentData } from "@/types/jsonTypes";
import Children from "@/components/Children.vue";
import plusCircleSrc from "@/assets/plus-circle-black.svg";
import minusCircleSrc from "@/assets/minus-circle-black.svg";
import { emitter } from "@/events";

export default defineComponent({
  name: "Parent",
  components: {
    Children,
  },
  data() {
    return {
      plusCircleSrc,
      minusCircleSrc,
      open: false,
    };
  },
  props: {
    main: {
      type: Object as PropType<ParentData>,
      required: true,
    },
    mainIndex: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    emitter.on("global-parent-handle", (evt: Record<string, boolean> | any) => {
      if (evt) {
        this.open = evt.open;
      }
    });
  },
});
</script>

<style scoped lang="scss">
.main-label {
  padding: 0 0.5rem;

  .parent-wrapper {
    cursor: pointer;
    color: #000;
    background: #fbbc6b;
    min-height: 40px;
    padding: 10px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    img {
      position: absolute;
      left: 2rem;
      &.circle-icon {
        pointer-events: none;
      }
    }

    h2 {
      padding-top: 0;
      margin-bottom: 0;
      font-size: 1.5rem;
      font-family: "Raleway", sans-serif;
    }

    @media screen and (max-width: 768px) {
      justify-content: flex-start;
      h2 {
        margin-left: 3.5rem;
        text-align: left;
      }
      img {
        left: 1.5rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.row.is-hidden {
  display: none;
}
</style>
